import React from "react";
import { Tooltip } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { EVENTS } from "../../../constants";
import { AmplitudeUtils } from "../../../utils";

const amplitudeCall = () => {
  AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.CREATE_DOC_CLICKED, {
    initiatedFrom: "swimlane",
  });
};

const CreateNewDocCard = props => {
  const disableBtn =
    !props.selectedOpp ||
    (props.selectedOpp.scope && !props.selectedOpp.scope.write);
  const card = (
    <div
      className="create-new-doc-card-wrapper"
      data-test="create-new-document-wrapper">
      <button
        data-test="create-new-document-button"
        className={`create-new-doc-card ${disableBtn &&
          "create-new-doc-card-disable"}`}
        type="button"
        disabled={disableBtn}
        onClick={() => {
          props.openCreateDocumentPopup(props.selectedOpp, false);
          amplitudeCall();
        }}>
        <i>
          <FontAwesomeIcon icon={["fas", "plus"]} />
        </i>
        Create document
      </button>
    </div>
  );

  if (!props.selectedOpp) {
    const btnDisabledToolTipMsg =
      "👈 You need to select an opportunity to create a document";
    return (
      <Tooltip
        placement="top"
        overlay={btnDisabledToolTipMsg}
        align={{
          offset: [0, 10],
        }}>
        {card}
      </Tooltip>
    );
  }
  if (props.selectedOpp.scope && !props.selectedOpp.scope.write) {
    const btnDisabledToolTipMsg =
      "Select an opportunity that you own, or have edit access to create a document";
    return (
      <Tooltip
        placement="top"
        overlay={btnDisabledToolTipMsg}
        align={{
          offset: [0, 10],
        }}>
        {card}
      </Tooltip>
    );
  }
  return card;
};

export default CreateNewDocCard;



// WEBPACK FOOTER //
// ./src/components/PipelineWrapper/CreateNewDocCard/CreateNewDocCard.js